import 'css-chunksrc/client/pages/documentsPage/reportsPage/filterForm/resourcesFilter/styles.scss';export default {
  "resourcesFilter": "_resourcesFilter_1jukt_1",
  "input": "_input_1jukt_7",
  "toggleArrow": "_toggleArrow_1jukt_23",
  "selectedResourcesNames": "_selectedResourcesNames_1jukt_31",
  "list": "_list_1jukt_40",
  "item": "_item_1jukt_53",
  "opened": "_opened_1jukt_61"
};